<div class="ktbl-row-mehrspaltig-2-elemente">
    
      <div class="ktbl-flex-item"   id="content_daten_7"></div>
      <div class="ktbl-flex-item"   id="content_daten_8"></div>
  
  </div>